module.exports = __webpack_public_path__ + "static/media/1986_GDP_totalRate.10ed325d.png";